import React from 'react';
import Button from './Button';
import BetaLink from '../../beta/BetaLink';

const Card = ({
  title,
  description,
  image,
  link,
  packaging,
  netWeight,
  variant = 'default'
}) => {
  const variants = {
    default: 'bg-white rounded-lg shadow-md overflow-hidden',
    circular: 'text-center',
    horizontal: 'bg-white flex flex-col md:flex-row gap-6'
  };

  if (variant === 'circular') {
    return (
      <div className={variants.circular}>
        <BetaLink to={link || '#'} className="block group">
          <div className="w-48 h-48 mx-auto mb-4 rounded-full overflow-hidden border-4 border-white shadow-lg">
            <img
              src={image}
              alt={title}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
            />
          </div>
        </BetaLink>
        <h3 className="text-lg font-bold uppercase tracking-wide mb-2">{title}</h3>
        <div className="w-16 h-0.5 bg-primary-red mx-auto mb-4" />
        <p className="text-gray-600 text-sm leading-relaxed mb-4 px-4">
          {description}
        </p>
        {link && (
          <Button href={link} variant="filled">
            MORE
          </Button>
        )}
      </div>
    );
  }

  if (variant === 'horizontal') {
    return (
      <div className={variants.horizontal}>
        <div className="md:w-1/3 flex-shrink-0">
          <img
            src={image}
            alt={title}
            className="w-full h-64 md:h-full object-cover rounded-lg"
          />
        </div>
        <div className="flex-1 py-4">
          <h3 className="text-2xl font-serif font-bold text-gray-900 mb-3">{title}</h3>
          <p className="text-gray-600 leading-relaxed mb-4">{description}</p>
          {(packaging || netWeight) && (
            <div className="text-sm text-gray-500 space-y-1">
              {packaging && <p><strong>Packaging:</strong> {packaging}</p>}
              {netWeight && <p><strong>Net Weight:</strong> {netWeight}</p>}
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={variants.default}>
      <div className="aspect-[4/3] overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-serif font-bold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
          {description}
        </p>
        {link && (
          <Button href={link} variant="filled" className="text-xs">
            Learn More
          </Button>
        )}
      </div>
    </div>
  );
};

export default Card;
